import React from "react";
import ScrollToTop from "../components/ScrollToTop";
import Signin from "../components/SigninMaterialUi";

const SignIn = () => {
  return (
    <>
      <ScrollToTop />
      <Signin />
    </>
  );
};

export default SignIn;
